import styled from "styled-components";
import {Button, Paper} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export const ButtonDelete = styled(Button)`
  background: rgb(246, 38, 38);
  color: white;
`;

export const ContentRewardStyled = styled.div`
  border: 1px solid ${props => props.isVisible === false ? 'none' : '#2392ea'};
  padding: ${props => props.isVisible === false ? 'none' : '10px'};
  border-radius: 5px;
`;

export const ContentItemListMeta = styled(Paper)`
    border: 10px;
    padding: 20px;
    border-radius: 10px;
`;

export const CheckCircleIconStyled = styled(CheckCircleIcon)`
  color: forestgreen;
`;

export const DividerStyled = styled.hr`
    color: white;
    border-color: white;
`;



